import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { FavoritesRouter } from '../../../favorites/types';
import { modules } from '../../modules';

@injectable()
export class FavoritesRouterService implements FavoritesRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${modules.favorites.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${modules.favorites.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToNews() {
    window.open(`/${modules.general_news.basename}`, '_blank');
  }

  goToFeed() {
    window.open(`/${modules.feed.basename}`, '_blank');
  }

  goToNewsItem(newsId: string) {
    window.open(`/${modules.general_news.basename}/${newsId}`, '_blank');
  }

  goToFeedItem(communityId: string, postId: string) {
    window.open(
      `/${modules.feed.basename}/${communityId}/post/${postId}`,
      '_blank',
    );
  }
}
